import { memo } from 'react';
import { Box, Skeleton } from '@bonanza-social/moonlight';
import { SKELETON_FILTERS } from './FiltersSkeleton.content';

function FiltersSkeleton() {
  return (
    <Box
      flexDirection="row"
      marginHorizontal="space-400"
      marginBottom="space-200"
      gap="space-200"
    >
      {SKELETON_FILTERS.map((id) => (
        <Skeleton key={id} width={88} height={32} />
      ))}
    </Box>
  );
}

export default memo(FiltersSkeleton);
